(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-agreement"] && !Shopify.designMode) return;
  try {
    (() => {
    const showError = (input) => {
      input.setAttribute('aria-invalid', 'true');
      const error = document.getElementById('CartAgreementError');
      if (error) error.hidden = false;
    };
    document.addEventListener('invalid', (event) => {
      if (event.target.matches('[data-cart-agreement]')) showError(event.target);
    }, true);
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input.matches('[data-cart-agreement]')) return;
      input.removeAttribute('aria-invalid');
      const error = document.getElementById('CartAgreementError');
      if (error) error.hidden = true;
    });
    document.addEventListener('submit', (event) => {
      if (event.target.id !== 'CartForm' || event.submitter?.name === 'update') return;
      const input = event.target.querySelector('[data-cart-agreement]');
      if (input && !input.checked) {
        event.preventDefault();
        showError(input);
        input.focus();
      }
    });
    window.addEventListener('pageshow', () => {
      const input = document.querySelector('[data-cart-agreement]');
      if (input) input.checked = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["catalog-filter"] && !Shopify.designMode) return;
  try {
    (() => {
  const TYPE_ALIASES = { jacke: 'jacken', lederjacke: 'jacken', winterjacke: 'jacken', jeansjacke: 'jacken', 'jeans-jacke': 'jacken', herrenjacke: 'jacken', bluse: 'blusen', kleid: 'kleider', 'mäntel': 'mantel', 'röcke': 'rock', hemden: 'hemd', 'hüte': 'hut', 't-shirt': 't-shirts', sakkos: 'sakko', strickjacke: 'strickjacken', sportjacke: 'trainingsjacken', sportjacken: 'trainingsjacken', trainingsjacke: 'trainingsjacken', lederhose: 'lederhosen', tasche: 'taschen', handtasche: 'taschen' };
  const COLOR_ALIASES = { bordo: 'bordeaux', burgundy: 'bordeaux', oliv: 'olive', khaki: 'olive', gray: 'grey', lila: 'purple', violet: 'purple', rosa: 'pink', multi: 'multicolor', bunt: 'multicolor', 'karo-white-red': ['red', 'white'] };
  const COLOR_ORDER = ['black', 'white', 'grey', 'beige', 'brown', 'red', 'bordeaux', 'pink', 'orange', 'yellow', 'green', 'olive', 'blue', 'purple', 'multicolor'];
  const SIZE_ORDER = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', '2xl', 'xxxl', '3xl', '4xl'];
  const PRICE_STEPS = ['2500', '5000', '7500', '10000'];
  const PARAMS = { gender: 'fuer', type: 'art', size: 'groesse', color: 'farbe', price: 'budget', sale: 'reduziert', available: 'verfuegbar', sort: 'sortierung' };
  const FACETS = ['gender', 'type', 'size', 'color'];
  const SORTS = ['featured', 'newest', 'price-asc', 'price-desc'];
  const slug = (value) => String(value ?? '').trim().toLowerCase().replace(/\s+/g, '-');
  const typeKey = (value) => TYPE_ALIASES[slug(value)] || slug(value);
  const colorKeys = (value) => {
    const alias = COLOR_ALIASES[slug(value)];
    return alias === undefined ? [slug(value)] : [].concat(alias);
  };
  const unique = (values) => [...new Set(values.filter(Boolean))];
  const sizeRank = (value) => {
    const key = slug(value);
    const letter = SIZE_ORDER.indexOf(key);
    if (letter >= 0) return [0, letter, key];
    const number = parseFloat(key.replace(',', '.'));
    return Number.isNaN(number) ? [2, 0, key] : [1, number, key];
  };
  const compareSizes = (a, b) => {
    const x = sizeRank(a);
    const y = sizeRank(b);
    return x[0] - y[0] || x[1] - y[1] || x[2].localeCompare(y[2]);
  };
  const readItem = (element, index) => {
    let data = {};
    try { data = JSON.parse(element.dataset.facets || '{}'); } catch { data = {}; }
    const women = data.w === true;
    const men = data.m === true;
    const gender = [];
    if (women) gender.push('women');
    if (men) gender.push('men');
    if (women === men) gender.push('unisex');
    const typeLabels = {};
    const types = unique((data.t || []).map((raw) => {
      const key = typeKey(raw);
      if (key && !typeLabels[key]) typeLabels[key] = String(raw).trim();
      return key;
    }));
    return {
      element,
      index,
      gender,
      types,
      typeLabels,
      sizes: unique((data.s || []).map((size) => String(size).trim())),
      colors: unique((data.c || []).flatMap(colorKeys)),
      price: Number(data.p) || 0,
      compare: Number(data.cp) || 0,
      available: data.a !== false,
      published: Number(data.d) || 0,
    };
  };
  const initialized = new WeakSet();
  const init = (root) => {
    if (initialized.has(root)) return;
    const grid = root.querySelector('[data-catalog-grid]');
    const labelsNode = root.querySelector('[data-catalog-labels]');
    if (!grid || !labelsNode) return;
    let labels;
    try { labels = JSON.parse(labelsNode.textContent); } catch { return; }
    const items = [...grid.querySelectorAll('[data-catalog-item]')].map(readItem);
    if (!items.length) return;
    initialized.add(root);
    const one = (name) => root.querySelector('[data-catalog-' + name + ']');
    const all = (name) => [...root.querySelectorAll('[data-catalog-' + name + ']')];
    const panel = one('panel');
    const pageSize = Math.max(4, Number(root.dataset.pageSize) || 24);
    const collator = new Intl.Collator(document.documentElement.lang || 'de', { numeric: true, sensitivity: 'base' });
    const state = { gender: new Set(), type: new Set(), size: new Set(), color: new Set(), price: '', sale: false, available: false, sort: 'featured', limit: pageSize };
    const typeLabel = (key) => labels.types?.[key] || items.find((item) => item.typeLabels[key])?.typeLabels[key] || key;
    const colorLabel = (key) => labels.colors?.[key] || key;
    const priceLabel = (value) => (value ? labels.upTo + ' ' + (labels.prices?.[value] || value) : labels.anyPrice);
    const labelFor = (facet, value) => {
      if (facet === 'gender') return labels.gender?.[value] || value;
      if (facet === 'type') return typeLabel(value);
      if (facet === 'color') return colorLabel(value);
      if (facet === 'price') return priceLabel(value);
      if (facet === 'sale') return labels.sale;
      if (facet === 'available') return labels.available;
      return value;
    };
    const valuesOf = (item, facet) => (facet === 'gender' ? item.gender : facet === 'type' ? item.types : facet === 'size' ? item.sizes : item.colors);
    const colorRank = (key) => (COLOR_ORDER.indexOf(key) === -1 ? COLOR_ORDER.length : COLOR_ORDER.indexOf(key));
    const optionValues = {
      gender: ['women', 'men', 'unisex'].filter((key) => items.some((item) => item.gender.includes(key))),
      type: unique(items.flatMap((item) => item.types)).sort((a, b) => collator.compare(typeLabel(a), typeLabel(b))),
      size: unique(items.flatMap((item) => item.sizes)).sort(compareSizes),
      color: unique(items.flatMap((item) => item.colors)).sort((a, b) => colorRank(a) - colorRank(b) || a.localeCompare(b)),
      price: PRICE_STEPS.filter((step) => items.some((item) => item.price <= Number(step))),
    };
    const passes = (item, except) => {
      for (const facet of FACETS) {
        if (facet === except || !state[facet].size) continue;
        if (!valuesOf(item, facet).some((value) => state[facet].has(value))) return false;
      }
      if (except !== 'price' && state.price && item.price > Number(state.price)) return false;
      if (except !== 'sale' && state.sale && !(item.compare > item.price)) return false;
      if (except !== 'available' && state.available && !item.available) return false;
      return true;
    };
    const buildOption = (facet, value, label, type = 'checkbox', name = '') => {
      const wrapper = document.createElement('label');
      wrapper.className = 'catalog-option';
      const input = document.createElement('input');
      input.type = type;
      if (name) input.name = name;
      input.value = value;
      input.dataset.facetInput = facet;
      wrapper.append(input);
      if (facet === 'color') {
        const swatch = document.createElement('span');
        swatch.className = 'catalog-option__swatch';
        swatch.dataset.color = value;
        swatch.setAttribute('aria-hidden', 'true');
        wrapper.append(swatch);
      }
      const text = document.createElement('span');
      text.className = 'catalog-option__label';
      text.textContent = label;
      const count = document.createElement('span');
      count.className = 'catalog-option__count';
      wrapper.append(text, count);
      return wrapper;
    };
    const container = (facet) => root.querySelector('[data-facet-options="' + facet + '"]');
    FACETS.forEach((facet) => {
      const target = container(facet);
      if (!target) return;
      target.replaceChildren(...optionValues[facet].map((value) => buildOption(facet, value, labelFor(facet, value))));
      target.closest('[data-facet]').hidden = optionValues[facet].length < 2;
    });
    if (container('price')) {
      const name = 'CatalogBudget-' + (panel?.id || 'panel');
      container('price').replaceChildren(buildOption('price', '', labels.anyPrice, 'radio', name), ...optionValues.price.map((step) => buildOption('price', step, priceLabel(step), 'radio', name)));
      container('price').closest('[data-facet]').hidden = optionValues.price.length === 0;
    }
    if (container('extra')) {
      const extras = [];
      if (items.some((item) => item.compare > item.price)) extras.push(buildOption('sale', '1', labels.sale));
      if (items.some((item) => !item.available)) extras.push(buildOption('available', '1', labels.available));
      container('extra').replaceChildren(...extras);
      container('extra').closest('[data-facet]').hidden = extras.length === 0;
    }
    const inputs = () => [...root.querySelectorAll('[data-facet-input]')];
    const syncInputs = () => inputs().forEach((input) => {
      const facet = input.dataset.facetInput;
      if (FACETS.includes(facet)) input.checked = state[facet].has(input.value);
      else if (facet === 'price') input.checked = input.value === state.price;
      else input.checked = Boolean(state[facet]);
      input.closest('.catalog-option')?.classList.toggle('is-active', input.checked);
    });
    const updateCounts = () => inputs().forEach((input) => {
      const facet = input.dataset.facetInput;
      let count = 0;
      if (FACETS.includes(facet)) count = items.filter((item) => passes(item, facet) && valuesOf(item, facet).includes(input.value)).length;
      else if (facet === 'price') count = items.filter((item) => passes(item, 'price') && (!input.value || item.price <= Number(input.value))).length;
      else if (facet === 'sale') count = items.filter((item) => passes(item, 'sale') && item.compare > item.price).length;
      else if (facet === 'available') count = items.filter((item) => passes(item, 'available') && item.available).length;
      const option = input.closest('.catalog-option');
      const countNode = option?.querySelector('.catalog-option__count');
      if (countNode) countNode.textContent = String(count);
      input.disabled = count === 0 && !input.checked;
      option?.classList.toggle('is-disabled', input.disabled);
    });
    const activeFilters = () => {
      const active = [];
      FACETS.forEach((facet) => optionValues[facet].forEach((value) => { if (state[facet].has(value)) active.push([facet, value]); }));
      if (state.price) active.push(['price', state.price]);
      if (state.sale) active.push(['sale', '1']);
      if (state.available) active.push(['available', '1']);
      return active;
    };
    const renderChips = (active) => {
      const target = one('chips');
      if (!target) return;
      const chips = active.map(([facet, value]) => {
        const label = labelFor(facet, value);
        const chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'catalog-chip';
        chip.dataset.chipFacet = facet;
        chip.dataset.chipValue = value;
        chip.setAttribute('aria-label', labels.remove.replace('%label%', label));
        const text = document.createElement('span');
        text.textContent = label;
        const cross = document.createElement('span');
        cross.setAttribute('aria-hidden', 'true');
        cross.textContent = '×';
        chip.append(text, cross);
        return chip;
      });
      if (chips.length) {
        const reset = document.createElement('button');
        reset.type = 'button';
        reset.className = 'catalog-chips__reset';
        reset.setAttribute('data-catalog-reset', '');
        reset.textContent = labels.reset;
        chips.push(reset);
      }
      target.replaceChildren(...chips);
      target.hidden = chips.length === 0;
    };
    const sortItems = (list) => {
      const modes = {
        newest: (a, b) => b.published - a.published || a.index - b.index,
        'price-asc': (a, b) => a.price - b.price || a.index - b.index,
        'price-desc': (a, b) => b.price - a.price || a.index - b.index,
      };
      const byMode = modes[state.sort] || ((a, b) => a.index - b.index);
      return [...list].sort((a, b) => Number(b.available) - Number(a.available) || byMode(a, b));
    };
    const writeUrl = () => {
      if (!window.history?.replaceState) return;
      const url = new URL(window.location.href);
      const set = (key, value) => (value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
      FACETS.forEach((facet) => set(PARAMS[facet], [...state[facet]].join(',')));
      set(PARAMS.price, state.price);
      set(PARAMS.sale, state.sale ? '1' : '');
      set(PARAMS.available, state.available ? '1' : '');
      set(PARAMS.sort, state.sort === 'featured' ? '' : state.sort);
      if (url.href !== window.location.href) window.history.replaceState(window.history.state, '', url);
    };
    const readUrl = () => {
      const params = new URLSearchParams(window.location.search);
      FACETS.forEach((facet) => (params.get(PARAMS[facet]) || '').split(',').forEach((value) => {
        const option = optionValues[facet].find((candidate) => String(candidate).toLowerCase() === value.trim().toLowerCase());
        if (option) state[facet].add(option);
      }));
      if (optionValues.price.includes(params.get(PARAMS.price))) state.price = params.get(PARAMS.price);
      state.sale = params.get(PARAMS.sale) === '1';
      state.available = params.get(PARAMS.available) === '1';
      if (SORTS.includes(params.get(PARAMS.sort))) state.sort = params.get(PARAMS.sort);
    };
    const update = ({ resetLimit = true } = {}) => {
      if (resetLimit) state.limit = pageSize;
      const matching = sortItems(items.filter((item) => passes(item)));
      const matched = new Set(matching);
      const rest = items.filter((item) => !matched.has(item));
      [...matching, ...rest].forEach((item) => grid.append(item.element));
      matching.forEach((item, position) => { item.element.hidden = position >= state.limit; });
      rest.forEach((item) => { item.element.hidden = true; });
      const total = matching.length;
      const countText = total === 0 ? labels.countNone : total === 1 ? labels.countOne : labels.count.replace('%count%', total);
      const counter = one('count');
      if (counter && counter.textContent !== countText) counter.textContent = countText;
      all('apply-count').forEach((node) => { node.textContent = String(total); });
      const empty = one('empty');
      if (empty) empty.hidden = total > 0;
      const more = one('more');
      if (more) {
        const remaining = total - state.limit;
        more.hidden = remaining <= 0;
        more.textContent = labels.more.replace('%count%', Math.min(pageSize, Math.max(remaining, 0)));
      }
      syncInputs();
      updateCounts();
      const active = activeFilters();
      renderChips(active);
      all('badge').forEach((badge) => { badge.textContent = String(active.length); badge.hidden = active.length === 0; });
      const sort = one('sort');
      if (sort) sort.value = state.sort;
      writeUrl();
      return matching;
    };
    const reset = () => {
      FACETS.forEach((facet) => state[facet].clear());
      state.price = '';
      state.sale = false;
      state.available = false;
      update();
    };
    const desktop = window.matchMedia ? window.matchMedia('(min-width: 990px)') : { matches: true, addEventListener() {} };
    let opener = null;
    const openPanel = (button) => {
      if (!panel) return;
      opener = button;
      panel.removeAttribute('role');
      if (typeof panel.showModal === 'function') { if (panel.open) panel.close(); panel.showModal(); } else panel.setAttribute('open', '');
      all('open').forEach((node) => node.setAttribute('aria-expanded', 'true'));
      panel.querySelector('[data-catalog-close]')?.focus();
    };
    const closePanel = () => {
      if (!panel || desktop.matches) return;
      if (typeof panel.close === 'function') panel.close(); else panel.removeAttribute('open');
      all('open').forEach((node) => node.setAttribute('aria-expanded', 'false'));
      if (opener?.isConnected) opener.focus();
    };
    const syncLayout = () => {
      if (!panel) return;
      if (desktop.matches) {
        if (panel.open && typeof panel.close === 'function') panel.close();
        panel.setAttribute('role', 'region');
        if (typeof panel.show === 'function') panel.show(); else panel.setAttribute('open', '');
      } else {
        if (typeof panel.close === 'function') panel.close(); else panel.removeAttribute('open');
        panel.removeAttribute('role');
      }
      all('open').forEach((node) => { node.hidden = desktop.matches; node.setAttribute('aria-expanded', 'false'); });
    };
    root.addEventListener('change', (event) => {
      const input = event.target;
      if (input.matches('[data-catalog-sort]')) {
        state.sort = SORTS.includes(input.value) ? input.value : 'featured';
        update();
        return;
      }
      if (!input.matches('[data-facet-input]')) return;
      const facet = input.dataset.facetInput;
      if (FACETS.includes(facet)) {
        if (input.checked) state[facet].add(input.value); else state[facet].delete(input.value);
      } else if (facet === 'price') {
        if (input.checked) state.price = input.value;
      } else if (facet === 'sale' || facet === 'available') {
        state[facet] = input.checked;
      }
      update();
    });
    root.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('button') : null;
      if (!button || !root.contains(button)) return;
      if (button.matches('[data-catalog-open]')) openPanel(button);
      else if (button.matches('[data-catalog-close]')) closePanel();
      else if (button.matches('[data-catalog-reset]')) reset();
      else if (button.matches('[data-chip-facet]')) {
        const facet = button.dataset.chipFacet;
        if (FACETS.includes(facet)) state[facet].delete(button.dataset.chipValue);
        else if (facet === 'price') state.price = '';
        else state[facet] = false;
        update();
        (one('chips')?.querySelector('button') || one('count'))?.focus?.();
      } else if (button.matches('[data-catalog-more]')) {
        const before = state.limit;
        state.limit += pageSize;
        const matching = update({ resetLimit: false });
        matching[before]?.element.querySelector('h3 a')?.focus();
      }
    });
    panel?.addEventListener('close', () => {
      if (!desktop.matches) all('open').forEach((node) => node.setAttribute('aria-expanded', 'false'));
    });
    desktop.addEventListener?.('change', syncLayout);
    readUrl();
    root.classList.add('catalog--ready');
    syncLayout();
    update({ resetLimit: false });
  };
  const start = (scope) => scope.querySelectorAll('[data-catalog]').forEach(init);
  start(document);
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cinema-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const APP_QUERY = '(max-width: 749px), (orientation: landscape) and (max-height: 500px) and (pointer: coarse)';
  const FOCUSABLE = 'a[href], button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const active = new WeakMap();
  const initialize = (scope) => {
    scope.querySelectorAll('[data-cinema]').forEach((root) => {
      if (active.has(root)) return;
      const aborter = new AbortController();
      const signal = aborter.signal;
      active.set(root, aborter);
      const get = (name) => root.querySelector('[data-cinema-' + name + ']');
      const all = (name) => root.querySelectorAll('[data-cinema-' + name + ']');
      let data, labels;
      try {
        data = JSON.parse(get('data').textContent);
        labels = JSON.parse(get('labels').textContent);
      } catch {
        get('error').textContent = root.dataset.error;
        get('error').hidden = false;
        return;
      }
      let products = data.products;
      let nextPage = data.next;
      let matches = [];
      let index = 0;
      let loading = false;
      let overlay = null;
      const appQuery = window.matchMedia(APP_QUERY);
      const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      const isApp = () => appQuery.matches;
      const storageKey = 'cc-cinema:' + location.pathname;
      let saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(storageKey)); } catch {}
      const filters = Object.fromEntries([...root.querySelectorAll('[data-filter]')].map(el => [el.dataset.filter, el]));
      const filterPanel = get('filters');
      const menuPanel = get('menu');
      const backdrop = get('backdrop');
      const detailsToggle = get('details-toggle');
      const more = get('more');
      const story = get('story');
      const STORY_KEY = 'cc-cinema-story:v1';
      const storySlides = story ? [...story.querySelectorAll('[data-cinema-story-slide]')] : [];
      const storyBars = story ? [...story.querySelectorAll('[data-cinema-story-bar]')] : [];
      let storyIndex = 0;
      const collator = new Intl.Collator(document.documentElement.lang || 'de', { numeric: true, sensitivity: 'base' });
      const substitute = (text, values) => Object.entries(values).reduce((str,[key,value]) => str.replaceAll('%' + key + '%', String(value)), text);
      const fillOptions = (select, values) => {
        const current = select.value;
        const first = select.options[0].cloneNode(true);
        select.replaceChildren(first);
        [...new Set(values.filter(Boolean))].sort(collator.compare).forEach(value => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.append(option);
        });
        select.value = [...select.options].some(option => option.value === current) ? current : '';
      };
      const populate = () => {
        fillOptions(filters.size, products.flatMap(product => product.sizes));
        fillOptions(filters.type, products.map(product => product.type));
      };
      const persist = () => {
        try { sessionStorage.setItem(storageKey, JSON.stringify({
          filters: Object.fromEntries(Object.entries(filters).map(([key, el]) => [key, el.type === 'checkbox' ? el.checked : el.value])),
          productId: matches[index]?.id
        })); } catch {}
      };
      const setText = (name, value) => { get(name).textContent = value; };
      const setAll = (name, value) => { all(name).forEach((node) => { node.textContent = value; }); };
      const responsiveSet = (url) => [400, 700, 1000, 1400].map(width => {
        try { const source = new URL(url, location.origin); source.searchParams.set('width', width); return source.href + ' ' + width + 'w'; } catch { return ''; }
      }).filter(Boolean).join(', ');
      const setLink = (name, href) => {
        const url = new URL(href, location.origin);
        if (url.origin === location.origin) get(name).href = url.href;
      };
      const replay = (node) => {
        if (!node) return;
        node.classList.remove('is-entering');
        void node.offsetWidth;
        node.classList.add('is-entering');
      };
      const render = (announce = true, direction = 0) => {
        const item = matches[index];
        const count = matches.length === 1 ? labels.countOne : substitute(labels.count, { count: matches.length });
        setText('count', count + (loading ? ' · ' + labels.loading : ''));
        const activeFilters = Object.values(filters).filter(el => el.type === 'checkbox' ? el.checked : el.value).length;
        const filterLabel = activeFilters ? substitute(labels.filterActive, {count: activeFilters}) : labels.filterToggle;
        setText('filter-summary', filterLabel);
        all('filter-open').forEach((button) => button.setAttribute('aria-label', filterLabel));
        all('filter-badge').forEach((badge) => { badge.textContent = String(activeFilters); badge.hidden = activeFilters === 0; });
        setAll('result-count', String(matches.length));
        get('stage').hidden = !item;
        get('empty').hidden = Boolean(item);
        get('controls').hidden = !item;
        persist();
        if (!item) {
          if (announce) setText('announcement', labels.empty);
          return;
        }
        setText('title', item.title);
        setText('type', item.type || labels.typeMissing);
        setText('kind', item.type || labels.typeMissing);
        setText('price', item.priceLabel);
        const discounted = item.compare > item.price;
        get('compare').hidden = !discounted;
        get('sale').hidden = !discounted;
        setText('compare', item.compareLabel);
        setAll('condition', labels[item.condition] || '');
        setText('gender', item.women && item.men ? labels.women + ' / ' + labels.men : item.women ? labels.women : item.men ? labels.men : labels.unisex);
        const sizeContainer = get('sizes');
        sizeContainer.replaceChildren();
        (item.sizes.length ? item.sizes : [labels.sizeMissing]).forEach(size => {
          const badge = document.createElement('span');
          badge.textContent = size;
          sizeContainer.append(badge);
        });
        setLink('product-link', item.url);
        setLink('image-link', item.url);
        const image = get('image');
        image.hidden = !item.image;
        get('no-image').hidden = Boolean(item.image);
        if (item.image) {
          image.srcset = responsiveSet(item.image);
          image.src = item.image;
          image.alt = item.title;
          image.decoding = 'async';
        } else {
          image.removeAttribute('srcset');
          image.removeAttribute('src');
        }
        setText('take', 'TAKE ' + String(index + 1).padStart(3, '0'));
        const position = substitute(labels.position, { current: index + 1, total: matches.length });
        setText('position', position);
        get('progress').style.width = (index + 1) / matches.length * 100 + '%';
        root.querySelectorAll('[data-cinema-prev],[data-cinema-next]').forEach(button => { button.disabled = matches.length < 2; });
        get('shuffle').disabled = matches.length < 2;
        if (direction) {
          root.style.setProperty('--cinema-shift', direction < 0 ? '-28px' : '28px');
          replay(image);
          replay(get('summary'));
        }
        if (announce) setText('announcement', position + '. ' + item.title + '. ' + item.priceLabel);
        const upcoming = matches[(index + 1) % matches.length];
        if (upcoming?.image && upcoming.image !== item.image) {
          const preload = new Image();
          preload.sizes = image.sizes;
          preload.srcset = responsiveSet(upcoming.image);
          preload.src = upcoming.image;
        }
      };
      const apply = (announce = true, preserve = false) => {
        const currentId = preserve ? matches[index]?.id : null;
        matches = products.filter(item => {
          const gender = filters.gender.value;
          if (gender === 'women' && !item.women) return false;
          if (gender === 'men' && !item.men) return false;
          if (gender === 'unisex' && !((item.women && item.men) || (!item.women && !item.men))) return false;
          if (filters.size.value && !item.sizes.includes(filters.size.value)) return false;
          if (filters.type.value && item.type !== filters.type.value) return false;
          if (filters.price.value && item.price > Number(filters.price.value)) return false;
          if (filters.sale.checked && item.compare <= item.price) return false;
          return true;
        });
        index = Math.max(0, matches.findIndex(item => item.id === currentId));
        render(announce);
      };
      const step = (offset, direction = Math.sign(offset)) => {
        if (!matches.length) return;
        index = (index + offset + matches.length) % matches.length;
        render(true, direction);
      };
      const setExpanded = (panel, value) => {
        if (!panel?.id) return;
        root.querySelectorAll('[aria-controls="' + panel.id + '"]').forEach((control) => control.setAttribute('aria-expanded', String(value)));
      };
      const background = () => [get('app-bar'), get('stage'), get('empty'), root.querySelector('.cinema__bar'), root.querySelector('.cinema__heading')].filter(Boolean);
      const readStory = () => {
        for (const area of ['localStorage', 'sessionStorage']) {
          try { return window[area].getItem(STORY_KEY); } catch {}
        }
        return null;
      };
      const rememberStory = () => {
        for (const area of ['localStorage', 'sessionStorage']) {
          try { window[area].setItem(STORY_KEY, '1'); return; } catch {}
        }
      };
      const closeOverlay = ({ restoreFocus = true, instant = false } = {}) => {
        if (!overlay) return;
        const { panel, trigger, modal, dim } = overlay;
        overlay = null;
        setExpanded(panel, false);
        if (modal) background().forEach((node) => { node.inert = false; });
        if (panel === story) rememberStory();
        const finish = () => {
          if (overlay?.panel === panel) return;
          panel.hidden = true;
          panel.classList.remove('is-closing');
          if (panel === filterPanel) {
            panel.removeAttribute('role');
            panel.removeAttribute('aria-modal');
            panel.removeAttribute('aria-labelledby');
          }
          if (dim && backdrop && !overlay) {
            backdrop.hidden = true;
            backdrop.classList.remove('is-closing');
          }
        };
        if (!instant && modal && !motionQuery.matches) {
          panel.classList.add('is-closing');
          if (dim && !overlay) backdrop?.classList.add('is-closing');
          window.setTimeout(finish, 230);
        } else {
          finish();
        }
        if (restoreFocus && modal && trigger?.isConnected) {
          const target = trigger.closest('[hidden]') ? (isApp() ? get('menu-open') : null) : trigger;
          target?.focus({ preventScroll: true });
        }
      };
      const openOverlay = (panel, trigger, { modal = isApp(), dim = isApp() } = {}) => {
        if (!panel) return;
        if (overlay) closeOverlay({ restoreFocus: false, instant: true });
        panel.classList.remove('is-closing');
        panel.hidden = false;
        setExpanded(panel, true);
        overlay = { panel, trigger, modal, dim };
        if (!modal) return;
        if (panel === filterPanel) {
          panel.setAttribute('role', 'dialog');
          panel.setAttribute('aria-modal', 'true');
          const title = panel.querySelector('[id^="CinemaFiltersTitle"]');
          if (title) panel.setAttribute('aria-labelledby', title.id);
        }
        if (dim && backdrop) {
          backdrop.classList.remove('is-closing');
          backdrop.hidden = false;
        }
        background().forEach((node) => { node.inert = true; });
        const target = panel.querySelector('[data-cinema-autofocus]') || panel.querySelector(FOCUSABLE);
        target?.focus({ preventScroll: true });
      };
      const renderStory = (direction = 0) => {
        if (!story) return;
        storySlides.forEach((slide, position) => { slide.hidden = position !== storyIndex; });
        storyBars.forEach((bar, position) => {
          bar.classList.toggle('is-done', position < storyIndex);
          bar.classList.toggle('is-current', position === storyIndex);
        });
        const back = get('story-prev');
        const next = get('story-next');
        const last = storyIndex === storySlides.length - 1;
        if (next) {
          next.textContent = last ? next.dataset.labelDone : next.dataset.labelNext;
          next.classList.toggle('is-final', last);
        }
        if (back) {
          if (storyIndex === 0 && document.activeElement === back) next?.focus({ preventScroll: true });
          back.hidden = storyIndex === 0;
        }
        if (direction) {
          root.style.setProperty('--cinema-shift', direction < 0 ? '-28px' : '28px');
          replay(storySlides[storyIndex]);
        }
      };
      const openStory = (trigger) => {
        if (!story || !storySlides.length) return;
        storyIndex = 0;
        renderStory();
        openOverlay(story, trigger, { modal: true, dim: false });
      };
      const stepStory = (offset) => {
        if (overlay?.panel !== story) return;
        const target = storyIndex + offset;
        if (target < 0) return;
        if (target >= storySlides.length) {
          closeOverlay();
          return;
        }
        storyIndex = target;
        renderStory(offset);
      };
      const detailsOpen = () => detailsToggle?.getAttribute('aria-expanded') === 'true';
      const setDetails = (open) => {
        if (!detailsToggle || !more) return;
        more.classList.toggle('is-open', open);
        detailsToggle.setAttribute('aria-expanded', String(open));
      };
      get('image').addEventListener('error', () => {
        get('image').hidden = true;
        get('no-image').hidden = false;
      }, {signal});
      root.addEventListener('change', event => {
        if (event.target.matches('[data-filter]')) apply();
      }, {signal});
      root.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !root.contains(button)) return;
        if (button.matches('[data-cinema-filter-toggle],[data-cinema-filter-open]')) {
          if (overlay?.panel === filterPanel) closeOverlay();
          else openOverlay(filterPanel, button);
        }
        if (button.hasAttribute('data-cinema-filter-close')) closeOverlay();
        if (button.hasAttribute('data-cinema-menu-open')) {
          if (overlay?.panel === menuPanel) closeOverlay();
          else openOverlay(menuPanel, button);
        }
        if (button.hasAttribute('data-cinema-menu-close')) closeOverlay();
        if (button.hasAttribute('data-cinema-story-open')) openStory(button);
        if (button.hasAttribute('data-cinema-story-close')) closeOverlay();
        if (button.hasAttribute('data-cinema-story-next')) stepStory(1);
        if (button.hasAttribute('data-cinema-story-prev')) stepStory(-1);
        if (button.hasAttribute('data-cinema-details-toggle')) setDetails(!detailsOpen());
        if (button.hasAttribute('data-cinema-prev')) step(-1);
        if (button.hasAttribute('data-cinema-next')) step(1);
        if (button.hasAttribute('data-cinema-shuffle') && matches.length > 1) step(1 + Math.floor(Math.random() * (matches.length - 1)), 1);
        if (button.hasAttribute('data-cinema-reset')) {
          Object.values(filters).forEach(filter => { filter.type === 'checkbox' ? filter.checked = false : filter.value = ''; });
          apply();
        }
        if (button.hasAttribute('data-cinema-retry')) loadRemaining();
      }, {signal});
      story?.addEventListener('click', (event) => {
        if (event.target === story) {
          closeOverlay();
          return;
        }
        const art = event.target.closest('[data-cinema-story-art]');
        if (!art) return;
        const bounds = art.getBoundingClientRect();
        stepStory(bounds.width && event.clientX < bounds.left + bounds.width / 3 ? -1 : 1);
      }, {signal});
      root.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          if (overlay?.modal) {
            event.preventDefault();
            closeOverlay();
            return;
          }
          if (detailsOpen()) {
            event.preventDefault();
            setDetails(false);
            detailsToggle.focus({ preventScroll: true });
            return;
          }
        }
        if (event.key === 'Tab' && overlay?.modal) {
          const nodes = [...overlay.panel.querySelectorAll(FOCUSABLE)].filter((node) => !node.closest('[hidden]'));
          if (!nodes.length) return;
          const first = nodes[0];
          const last = nodes[nodes.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
          return;
        }
        if (overlay?.panel === story && (event.key === 'ArrowRight' || event.key === 'ArrowLeft')) {
          event.preventDefault();
          stepStory(event.key === 'ArrowRight' ? 1 : -1);
          return;
        }
        if (overlay?.modal) return;
        if (event.target.closest('input,select,textarea,[contenteditable="true"]')) return;
        if (event.altKey || event.metaKey || event.ctrlKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          step(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, {signal});
      backdrop?.addEventListener('click', () => closeOverlay(), {signal});
      menuPanel?.addEventListener('click', (event) => {
        if (event.target.closest('a[href]')) closeOverlay({ restoreFocus: false, instant: true });
      }, {signal});
      const addSwipe = (element, onSwipe, allowed = () => true) => {
        if (!element) return;
        let touchStart = null;
        let swallowClick = false;
        element.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) { touchStart = null; return; }
          touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
        }, {passive: true, signal});
        element.addEventListener('touchcancel', () => { touchStart = null; }, {passive: true, signal});
        element.addEventListener('touchend', (event) => {
          if (!touchStart || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - touchStart.x;
          const dy = event.changedTouches[0].clientY - touchStart.y;
          touchStart = null;
          if (!allowed() || Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
          swallowClick = true;
          window.setTimeout(() => { swallowClick = false; }, 450);
          onSwipe(dx < 0 ? 1 : -1);
        }, {passive: true, signal});
        element.addEventListener('click', (event) => {
          if (!swallowClick) return;
          swallowClick = false;
          event.preventDefault();
          event.stopPropagation();
        }, {capture: true, signal});
      };
      addSwipe(root.querySelector('.cinema__frame'), (direction) => step(direction), () => matches.length > 1);
      addSwipe(story?.querySelector('.cinema-story__card'), (direction) => stepStory(direction));
      if (typeof appQuery.addEventListener === 'function') {
        appQuery.addEventListener('change', () => {
          if (overlay && overlay.panel !== story) closeOverlay({ restoreFocus: false, instant: true });
          setDetails(false);
        }, {signal});
      }
      const screen = root.querySelector('.cinema__screen');
      if (screen && 'ResizeObserver' in window) {
        const observer = new ResizeObserver(() => {
          root.style.setProperty('--cinema-more-max', Math.round(screen.getBoundingClientRect().height) + 'px');
        });
        observer.observe(screen);
        signal.addEventListener('abort', () => observer.disconnect());
      }
      const loadRemaining = async () => {
        if (loading || !nextPage) return;
        loading = true;
        get('error').hidden = true;
        get('retry').hidden = true;
        render(false);
        const seen = new Set();
        try {
          while (nextPage && root.isConnected && !signal.aborted) {
            const url = new URL(nextPage, location.origin);
            if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid page');
            seen.add(url.href);
            url.searchParams.set('view', 'cinema');
            url.searchParams.set('section_id', root.dataset.sectionId);
            const response = await fetch(url, {signal});
            if (!response.ok) throw new Error('Request failed');
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const chunk = JSON.parse(html.querySelector('[data-cinema-data]').textContent);
            const ids = new Set(products.map(product => product.id));
            products.push(...chunk.products.filter(product => !ids.has(product.id)));
            nextPage = chunk.next;
            populate();
            apply(false, true);
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            setText('error', labels.error);
            get('error').hidden = false;
            get('retry').hidden = false;
          }
        } finally {
          loading = false;
          if (root.isConnected) render(false);
        }
      };
      populate();
      if (saved?.filters) {
        Object.entries(filters).forEach(([key, el]) => {
          if (el.type === 'checkbox') el.checked = saved.filters[key] === true;
          else if ([...el.options].some(option => option.value === saved.filters[key])) el.value = saved.filters[key];
        });
      }
      filterPanel.hidden = true;
      get('filter-toggle').hidden = false;
      get('filter-toggle').setAttribute('aria-expanded', 'false');
      get('keyboard').hidden = false;
      setDetails(false);
      apply(false);
      if (saved?.productId) {
        const previous = matches.findIndex(item => item.id === saved.productId);
        if (previous >= 0) { index = previous; render(false); }
      }
      loadRemaining();
      if (story && !readStory() && !window.Shopify?.designMode) {
        window.setTimeout(() => {
          if (!overlay && root.isConnected && !signal.aborted) openStory(null);
        }, 450);
      }
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-cinema]').forEach(root => active.get(root)?.abort());
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["consent-banner-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    let openBanner = null;
    let returnFocus = null;
    let pending = false;
    const visible = (element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    const focusable = (banner) => [...banner.querySelectorAll('a[href], button, input, [tabindex="0"]')].filter(element => !element.disabled && visible(element));
    const enhance = () => {
      pending = false;
      const banner = document.getElementById('banner-wrapper');
      if (!banner) return;
      if (banner.getAttribute('role') !== 'dialog') {
        banner.setAttribute('role', 'dialog');
        banner.setAttribute('aria-modal', 'true');
        banner.setAttribute('aria-label', banner.querySelector('.banner-header__title')?.textContent.trim() || 'Cookies');
      }
      banner.querySelectorAll('.banner-main_buttons p').forEach(button => {
        if (button.getAttribute('role') === 'button') return;
        button.setAttribute('role', 'button');
        button.tabIndex = 0;
        button.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          (button.querySelector('[data-cookie-accept-all], [data-cookie-save]') || button).click();
        });
      });
      const isOpen = visible(banner) && getComputedStyle(banner).display !== 'none';
      if (isOpen && openBanner !== banner) {
        returnFocus = document.activeElement;
        openBanner = banner;
        focusable(banner)[0]?.focus();
      } else if (!isOpen && openBanner === banner) {
        openBanner = null;
        if (returnFocus?.isConnected) returnFocus.focus();
      }
    };
    document.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || !openBanner) return;
      const elements = focusable(openBanner);
      const first = elements[0];
      const last = elements[elements.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !openBanner.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !openBanner.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    });
    new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(enhance);
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    enhance();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["contact-ticket-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const ALPHABET = 'ACDEFHJKMNPRTUVWXY34679';
  const LENGTH = 5;
  const MIN_FILL_MS = 2500;
  const MAX_ATTEMPTS = 3;
  const WIDTH = 232;
  const HEIGHT = 76;
  const active = new WeakMap();

  const secureInt = (max) => {
    const values = new Uint32Array(1);
    window.crypto.getRandomValues(values);
    return values[0] % max;
  };
  const createCode = () => Array.from({ length: LENGTH }, () => ALPHABET[secureInt(ALPHABET.length)]).join('');
  const normalize = (value) => String(value || '').toUpperCase().replace(/\s+/g, '');
  const cssValue = (element, name, fallback) => {
    const value = window.getComputedStyle(element).getPropertyValue(name).trim();
    return value || fallback;
  };

  const draw = (canvas, code) => {
    const context = typeof canvas.getContext === 'function' ? canvas.getContext('2d') : null;
    if (!context) return false;
    const ratio = Math.min(window.devicePixelRatio || 1, 3);
    canvas.width = Math.round(WIDTH * ratio);
    canvas.height = Math.round(HEIGHT * ratio);
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
    const root = document.documentElement;
    const ink = cssValue(root, '--ink', '#242021');
    const accent = cssValue(root, '--accent', '#501e34');
    const paper = cssValue(root, '--paper', '#f3efe5');
    const family = cssValue(root, '--vintage', 'Georgia, serif');
    context.clearRect(0, 0, WIDTH, HEIGHT);
    context.fillStyle = paper;
    context.fillRect(0, 0, WIDTH, HEIGHT);
    for (let dot = 0; dot < 110; dot += 1) {
      context.fillStyle = dot % 3 ? 'rgba(36, 32, 33, 0.16)' : 'rgba(80, 30, 52, 0.24)';
      context.fillRect(Math.random() * WIDTH, Math.random() * HEIGHT, 1.5, 1.5);
    }
    const step = (WIDTH - 32) / code.length;
    Array.from(code).forEach((character, index) => {
      context.save();
      context.translate(16 + step * index + step / 2, HEIGHT / 2 + (Math.random() * 12 - 6));
      context.rotate(((Math.random() * 30 - 15) * Math.PI) / 180);
      context.font = `700 ${Math.round(32 + Math.random() * 8)}px ${family}`;
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillStyle = index % 2 ? accent : ink;
      context.fillText(character, 0, 0);
      context.restore();
    });
    for (let line = 0; line < 2; line += 1) {
      context.beginPath();
      context.moveTo(6, 16 + Math.random() * 44);
      context.bezierCurveTo(70, Math.random() * HEIGHT, 160, Math.random() * HEIGHT, WIDTH - 6, 16 + Math.random() * 44);
      context.strokeStyle = line ? 'rgba(80, 30, 52, 0.5)' : 'rgba(36, 32, 33, 0.42)';
      context.lineWidth = 1.5;
      context.stroke();
    }
    return true;
  };

  const localVoice = (language) => {
    if (!('speechSynthesis' in window) || typeof window.SpeechSynthesisUtterance !== 'function') return null;
    const voices = window.speechSynthesis.getVoices().filter((voice) => voice.localService);
    return voices.find((voice) => voice.lang.toLowerCase().startsWith(language)) || null;
  };

  const initialize = (scope) => {
    scope.querySelectorAll('[data-contact-ticket]').forEach((ticket) => {
      if (active.has(ticket)) return;
      const aborter = new AbortController();
      const { signal } = aborter;
      active.set(ticket, aborter);
      const get = (name) => ticket.querySelector(`[data-contact-${name}]`);
      const success = get('success');
      if (success) {
        success.focus({ preventScroll: true });
        success.scrollIntoView?.({ block: 'center' });
        return;
      }
      const form = ticket.querySelector('form');
      const fields = get('fields');
      const canvas = get('canvas');
      const input = get('code-input');
      const status = get('code-status');
      const okBadge = get('code-ok');
      const proof = get('proof');
      const honeypot = get('honeypot');
      const submit = get('submit');
      const speak = get('speak');
      if (!form || !fields || !canvas || !input || !status || !proof || !submit) return;

      let code = createCode();
      let attempts = 0;
      let openedAt = Date.now();
      if (!draw(canvas, code)) return;
      document.fonts?.ready?.then(() => {
        if (!signal.aborted) draw(canvas, code);
      });
      fields.disabled = false;
      const noscript = get('noscript');
      if (noscript) noscript.hidden = true;

      const params = new URLSearchParams(window.location.search);
      const article = get('article');
      const articleValue = params.get('artikel') || params.get('item');
      if (article && articleValue && !article.value) article.value = articleValue.slice(0, 300);
      const topic = params.get('anliegen') || params.get('topic');
      if (topic) {
        const option = Array.from(ticket.querySelectorAll('[data-topic]')).find((radio) => radio.dataset.topic === topic);
        if (option) option.checked = true;
      }

      const announce = (message) => {
        status.textContent = '';
        window.setTimeout(() => {
          status.textContent = message;
        }, 30);
      };
      const renew = () => {
        code = createCode();
        attempts = 0;
        input.value = '';
        if (okBadge) okBadge.hidden = true;
        draw(canvas, code);
      };

      get('refresh')?.addEventListener(
        'click',
        () => {
          renew();
          input.removeAttribute('aria-invalid');
          announce(status.dataset.renewed);
          input.focus();
        },
        { signal },
      );

      const language = (status.dataset.voice || document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
      const showSpeak = () => {
        if (speak) speak.hidden = !localVoice(language);
      };
      showSpeak();
      if ('speechSynthesis' in window) {
        window.speechSynthesis.addEventListener?.('voiceschanged', showSpeak, { signal });
      }
      speak?.addEventListener(
        'click',
        () => {
          const voice = localVoice(language);
          if (!voice) return;
          window.speechSynthesis.cancel();
          const utterance = new window.SpeechSynthesisUtterance(Array.from(code).join(', '));
          utterance.voice = voice;
          utterance.lang = voice.lang;
          utterance.rate = 0.65;
          window.speechSynthesis.speak(utterance);
          input.focus();
        },
        { signal },
      );

      input.addEventListener(
        'input',
        () => {
          const matches = normalize(input.value) === code;
          if (okBadge) okBadge.hidden = !matches;
          if (matches) {
            input.removeAttribute('aria-invalid');
            status.textContent = '';
          }
        },
        { signal },
      );

      // The guard listens on the document in the capture phase: Shopify's own form script
      // binds a submit listener on the form itself and then submits it natively, which would
      // bypass a listener bound later on the form. Capturing first and stopping the event
      // keeps the entry code in charge.
      document.addEventListener(
        'submit',
        (event) => {
          if (event.target !== form) return;
          const stop = () => {
            event.preventDefault();
            event.stopImmediatePropagation();
          };
          if (honeypot && honeypot.value) {
            stop();
            return;
          }
          if (Date.now() - openedAt < MIN_FILL_MS) {
            stop();
            openedAt = Date.now() - MIN_FILL_MS;
            announce(status.dataset.tooFast);
            return;
          }
          if (!input.value.trim()) {
            stop();
            input.setAttribute('aria-invalid', 'true');
            announce(status.dataset.missing);
            input.focus();
            return;
          }
          if (normalize(input.value) !== code) {
            stop();
            attempts += 1;
            input.setAttribute('aria-invalid', 'true');
            if (attempts >= MAX_ATTEMPTS) {
              renew();
              announce(status.dataset.renewed);
            } else {
              input.value = '';
              announce(status.dataset.error);
            }
            input.focus();
            return;
          }
          proof.value = ticket.dataset.proof || 'OK';
          window.setTimeout(() => {
            submit.disabled = true;
          }, 0);
          const label = ticket.querySelector('[data-contact-submit-label]');
          if (label && submit.dataset.sending) label.textContent = submit.dataset.sending;
        },
        { capture: true, signal },
      );
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-contact-ticket]').forEach((ticket) => active.get(ticket)?.abort());
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["premiere-script"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialized = new WeakSet();
  const initialize = scope => scope.querySelectorAll('[data-premiere]').forEach(root => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const cards = [...root.querySelectorAll('[data-premiere-card]')];
    if (cards.length < 2) return;
    const position = root.querySelector('[data-premiere-position]');
    const status = root.querySelector('[data-premiere-status]');
    let index = 0;
    const show = announce => {
      cards.forEach((card, i) => { card.hidden = i !== index; });
      position.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(cards.length).padStart(2, '0');
      const nextImage = cards[(index + 1) % cards.length].querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
      if (announce) status.textContent = position.textContent + '. ' + cards[index].dataset.announcement;
    };
    root.querySelector('[data-premiere-controls]').hidden = false;
    root.addEventListener('click', event => {
      const next = event.target.closest('[data-premiere-next]');
      const previous = event.target.closest('[data-premiere-prev]');
      if (!next && !previous) return;
      index = (index + (next ? 1 : -1) + cards.length) % cards.length;
      show(true);
    });
    show(false);
  });
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-script"] && !Shopify.designMode) return;
  try {
    (() => {
    const requests = new WeakMap();
    document.addEventListener('change', (event) => {
      const select = event.target instanceof HTMLSelectElement ? event.target : null;
      if (!select?.matches('[data-locale-autosubmit]') || !select.form) return;
      const form = select.form;
      if (select.dataset.language && !form.querySelector('input[name="language_code"]')) {
        const language = document.createElement('input');
        language.type = 'hidden';
        language.name = 'language_code';
        language.value = select.dataset.language;
        form.append(language);
      }
      form.submit();
    });
    document.addEventListener('change', async (event) => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.matches('[data-option-value-id]'))
        return;
      const root = event.target.closest('[data-product-root]');
      if (!root) return;
      const pending = requests.get(root);
      pending?.controller.abort();
      const controller = new AbortController();
      const selectedId = event.target.dataset.optionValueId;
      const status = root.querySelector('[data-product-status]');
      const addButton = root.querySelector('[data-add-button]');
      const variantInput = root.querySelector('[data-variant-input]');
      const wasDisabled = pending?.buttonDisabled ?? addButton?.disabled;
      const inputWasDisabled = pending?.variantDisabled ?? variantInput?.disabled;
      requests.set(root, { controller, buttonDisabled: wasDisabled, variantDisabled: inputWasDisabled });
      if (addButton) addButton.disabled = true;
      if (variantInput) variantInput.disabled = true;
      root.setAttribute('aria-busy', 'true');
      if (status) status.textContent = '';
      const url = new URL(root.dataset.productUrl, window.location.origin);
      const optionValues = Array.from(
        root.querySelectorAll('[data-option-value-id]:checked'),
        (input) => input.dataset.optionValueId,
      ).join(',');
      url.searchParams.set('section_id', root.dataset.sectionId);
      url.searchParams.set('option_values', optionValues);
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Variant request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const updated = html.querySelector('[data-product-root]');
        if (
          !updated ||
          updated.dataset.sectionId !== root.dataset.sectionId ||
          !updated.querySelector('[data-add-button]')
        )
          throw new Error('Invalid variant response');
        if (controller.signal.aborted || !root.isConnected) return;
        root.replaceWith(updated);
        const selectedInput = Array.from(updated.querySelectorAll('[data-option-value-id]')).find(
          (input) => input.dataset.optionValueId === selectedId,
        );
        selectedInput?.focus({ preventScroll: true });
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('option_values');
        if (updated.dataset.variantId) {
          currentUrl.searchParams.set('variant', updated.dataset.variantId);
        } else {
          currentUrl.searchParams.delete('variant');
          currentUrl.searchParams.set('option_values', optionValues);
        }
        window.history.replaceState({}, '', currentUrl);
        window.Shopify?.PaymentButton?.init();
      } catch (error) {
        if (error.name === 'AbortError' || controller.signal.aborted) return;
        root.querySelectorAll('[data-option-value-id]').forEach((input) => {
          input.checked = input.defaultChecked;
        });
        if (addButton) addButton.disabled = wasDisabled;
        if (variantInput) variantInput.disabled = inputWasDisabled;
        if (status) status.textContent = status.dataset.error;
      } finally {
        if (requests.get(root)?.controller === controller) {
          root.removeAttribute('aria-busy');
          requests.delete(root);
        }
      }
    });
    document.addEventListener('click', async (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      document.querySelectorAll('[data-mobile-menu][open],.nav-dropdown[open]').forEach((details) => {
        if (!details.contains(target)) details.open = false;
      });
      const share = target.closest('[data-share]');
      if (share) {
        const status = share.parentElement.querySelector('[data-share-status]');
        const label = share.querySelector('[data-share-label]');
        const url = share.dataset.url || window.location.href;
        let copied = false;
        try {
          await navigator.clipboard.writeText(url);
          copied = true;
        } catch {
          const field = document.createElement('textarea');
          field.value = url;
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.opacity = '0';
          document.body.append(field);
          field.select();
          try {
            copied = document.execCommand('copy');
          } catch {
            copied = false;
          }
          field.remove();
        }
        if (status) status.textContent = copied ? share.dataset.copied : share.dataset.error;
        if (copied && label) {
          label.textContent = share.dataset.copied;
          share.classList.add('is-copied');
          window.clearTimeout(Number(share.dataset.resetTimer));
          share.dataset.resetTimer = String(
            window.setTimeout(() => {
              label.textContent = share.dataset.label || label.textContent;
              share.classList.remove('is-copied');
            }, 2200),
          );
        }
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-mobile-menu][open],.nav-dropdown[open]').forEach((details) => {
        details.open = false;
        details.querySelector('summary')?.focus();
      });
    });
    document.addEventListener(
      'toggle',
      (event) => {
        const opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.open || !opened.matches('.nav-dropdown'))
          return;
        document.querySelectorAll('.nav-dropdown[open]').forEach((details) => {
          if (details !== opened) details.open = false;
        });
      },
      true,
    );
    document.addEventListener(
      'play',
      (event) => {
        if (!(event.target instanceof HTMLVideoElement)) return;
        document.querySelectorAll('.social-card video').forEach((video) => {
          if (video !== event.target) video.pause();
        });
      },
      true,
    );
    const loadRecommendations = async (element) => {
      if (element.dataset.loaded || !element.dataset.url) return;
      element.dataset.loaded = 'true';
      try {
        const url = new URL(element.dataset.url, window.location.origin);
        if (url.origin !== window.location.origin) return;
        const response = await fetch(url);
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('[data-recommendations]');
        if (content && element.isConnected) element.innerHTML = content.innerHTML;
      } catch {}
    };
    const observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  observer.unobserve(entry.target);
                  loadRecommendations(entry.target);
                }
              });
            },
            { rootMargin: '400px' },
          )
        : null;
    const initialize = (scope) => {
      scope.querySelectorAll('[data-recommendations]').forEach((element) => {
        if (observer) observer.observe(element);
        else loadRecommendations(element);
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target
        .querySelectorAll('[data-product-root]')
        .forEach((root) => requests.get(root)?.controller.abort());
      event.target
        .querySelectorAll('[data-recommendations]')
        .forEach((element) => observer?.unobserve(element));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
